import {Dropdown} from "react-bootstrap";
import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";
import PopupOrderDetails from "./PopupOrderDetails";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PopupDeleteOrder from "./PopupDeleteOrder";
import DownloadExtract from "./DownloadExtract";
import {ApiUrl} from "../../../auth/authMethods";
import {useUser} from "../../../auth/AuthProvider";
import AddContrato from "./AddContrato";
import PopupEditRecipient from "./PopupEditRecipient";
import PopupBoletos from "./PopupBoletos";
import PopupLogBook from "../../../component/LogBook/PopupLogBook";
import PopupConsentFile from "./PopupConsentFile";
import PopupSendAllBankslips from "./PopupSendAllBankslips";
import InstallmentsSwitch from "./InstallmentsSwitch/InstallmentsSwitch";
import OrderManagement from "./OrderManagement";

export default function OrderActions({item, setLoadData}) {

    const baseUrl = `${ApiUrl}/pedidos`
    const {user} = useUser()

    const detailsLabel = <>
        <VisibilityIcon fontSize="medium"/>
        &nbsp; Detalhes do Lote
    </>

    return <Dropdown drop='down-centered'>
        <Dropdown.Toggle variant="secondary">
            Ações &nbsp;
            <SettingsIcon fontSize="medium"/>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <PopupOrderDetails
                item={item} setLoadData={setLoadData}
                label={detailsLabel} buttonClass={'dropdown-item'}/>
            <PopupBoletos
                item={item} setLoadData={setLoadData}
                buttonClass={'dropdown-item'}/>
            <DownloadExtract id={item.id} lote={item.numero}/>

            {user.isAdmin && <>
                <PopupLogBook item={item}/>
                <AddContrato pedidoId={item.id} setLoadData={setLoadData}/>
                <OrderManagement item={item}/>
                <PopupEditRecipient item={item} setLoadData={setLoadData}/>
                <PopupConsentFile pedidoId={item.id} setLoadData={setLoadData}/>
                <PopupSendAllBankslips id={item.id}/>
                <InstallmentsSwitch orderId={item.id} setLoadData={setLoadData}/>
                <hr className="mb-1 mt-1"/>
                {item.status !== 'Inativo' &&
                    <PopupDeleteOrder item={item} setLoadData={setLoadData} baseUrl={baseUrl}/>
                }
            </>}
        </Dropdown.Menu>

    </Dropdown>
}